import {
  convertUTCDateTimeToLocal,
  toDate,
  toDisplayDate,
  toDisplayDateTime,
} from "../blocks/fields/formatDate";
import { FieldConfig } from "./fieldConfig.types";

const isEmpty = (value: unknown) =>
  value === null || value === undefined || value === "";

/**
 * A field's value as the text a read-only page shows in place of its control. Empty
 * when there is nothing to show; an entity lookup's name is not known here.
 */
export function fieldDisplayText(field: FieldConfig, value: unknown): string {
  switch (field.type) {
    case "boolean":
    case "checkbox":
      return value === true ? "Yes" : "No";
    case "date":
      return toDisplayDate(value as string);
    case "datetime":
      return toDisplayDateTime(
        field.storedAsLocal
          ? toDate(value as string)
          : convertUTCDateTimeToLocal(value as string)?.toDate()
      );
    case "time":
      return /(\d{2}):(\d{2})/.exec(String(value ?? ""))?.[0] ?? "";
    case "money":
      return isEmpty(value)
        ? ""
        : new Intl.NumberFormat("en-GB", {
            style: "currency",
            currency: field.currency ?? "GBP",
          }).format(Number(value));
    case "radio":
      return field.options.find((option) => option.value === value)?.label ?? "";
    case "picklist":
      return (
        field.options.find((option) => String(option.Key) === String(value))
          ?.Value ?? ""
      );
    case "lookup":
      return (
        field.options?.find((option) => option.id === String(value))
          ?.displayName ?? ""
      );
    case "multiselect": {
      const picked = Array.isArray(value) ? value.map(String) : [];
      return field.options
        .filter((option) => picked.includes(String(option.value)))
        .map((option) => option.label)
        .join(", ");
    }
    case "richtext":
      return isEmpty(value)
        ? ""
        : new DOMParser().parseFromString(String(value), "text/html").body.textContent ?? "";
    default:
      return isEmpty(value) ? "" : String(value);
  }
}
